import { Injectable } from '@angular/core';
import { GlobalHttpClient } from '../global.http.client';
import { BaseService } from './base.service';

@Injectable()
export class PaymentService extends BaseService {
    constructor(http: GlobalHttpClient) {
        super(http);
    }

    sendSubscriptionReceipt(paymentId: number) {
        var response = this.http.post('payments/sendSubscriptionReceipt', paymentId);

        return response;
    }

    getPaymentStatus(paymentId: number) {
        return this.http.get(`payments/getStatus/${paymentId}`);
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/services/payment.service.ts